var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI / Mapicons / Start@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.34998108,11.1946122 C3.34998108,11.1946122 3.34686217,11.1914933 3.34686217,11.1883744 L2.71060486,12.7790177 C2.64822669,12.9349631 2.55465944,13.0784329 2.43302201,13.1969514 L0.611579516,15.0215128 C0.318402128,15.3146902 0.318402128,15.7887643 0.611579516,16.0788227 C0.75816821,16.2254114 0.948421621,16.2971463 1.13867503,16.2971463 C1.32892844,16.2971463 1.52230076,16.2254114 1.66577055,16.0788227 L3.48721304,14.2542613 C3.75232026,13.9891541 3.9550493,13.6772633 4.09228127,13.3341834 L4.5133339,12.2831112 L3.38428907,11.2382769 L3.34998108,11.1946122 Z M6.87434755,3.3412009 C7.70085827,3.3412009 8.36830466,2.6706356 8.36830466,1.84412488 C8.36830466,1.01761416 7.69773936,0.347048853 6.87434755,0.347048853 C6.04783683,0.347048853 5.38039043,1.01761416 5.38039043,1.84412488 C5.38039043,2.6706356 6.04783683,3.3412009 6.87434755,3.3412009 Z M10.1398446,8.79617166 L9.22600447,7.89480714 C9.19793429,7.86673696 9.17610193,7.83242897 9.1636263,7.79500207 L8.76128712,6.58486562 C8.31216431,5.2406161 7.06460096,4.33925158 5.64861655,4.33925158 C4.56323644,4.33925158 3.99559511,4.61371552 2.66382123,5.15016776 C2.01196938,5.41215607 1.48175495,5.90182468 1.16050739,6.54743872 L0.711384584,7.51741922 C0.296569769,8.41254593 1.65017601,9.04880324 2.06810973,8.14743872 L2.5047569,7.19929057 C2.65446451,6.89987536 2.90709609,6.66907614 3.21586801,6.54431981 C3.89267113,6.27297478 4.24822669,6.12326718 4.59754443,6.01098648 L3.98000057,8.48116191 C3.83341187,9.0706356 3.98935729,9.69129837 4.44471792,10.1840859 L6.90865554,12.460889 C7.09267113,12.632429 7.22054638,12.8507526 7.27668673,13.0971463 L7.88487386,15.7419806 C7.96596548,16.1006551 8.33399667,16.4031892 8.78000057,16.3033841 C9.18233975,16.2098169 9.43185242,15.8074777 9.33828517,15.4051385 L8.73009803,12.7634231 C8.6053417,12.223852 8.32463994,11.7404212 7.91918186,11.3630333 L6.24120915,9.8160547 L7.05836314,6.54743872 C7.28916236,6.84997283 7.29228127,6.94042117 7.73828517,8.27531396 C7.8256146,8.53418336 7.9722033,8.77122039 8.16869453,8.96771162 L9.08253468,9.87219505 C9.77805125,10.5427604 10.8509557,9.50104495 10.1398446,8.79617166 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(7.117302, 4.165139)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.117302, -4.165139)",
    id: "Color-/-Secondary-/-Hover"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#394854",
    x: 0,
    y: 0,
    width: 34.2,
    height: 34.2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.5375483435b93b9945b5faa4c2d701c1.svg";
export { ForwardRef as ReactComponent };